export default class Event {
  constructor (data = {}) {
    this._id = data._id;
    this.message = data.message || null;
    this.detail = data.detail || null;
    this.createdAt = data.createdAt || null;
  }
}
